import * as tslib_1 from "tslib";
import * as React from 'react';
import { BaseComponent } from '../../Utilities';
import { BaseButton } from '../../Button';
import { getTheme } from '../../Styling';
import { getStyles } from '../Button/BaseButton.styles';
var FacepileButton = /** @class */ (function (_super) {
    tslib_1.__extends(FacepileButton, _super);
    function FacepileButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FacepileButton.prototype.render = function () {
        var baseButtonStyles = getStyles(getTheme());
        return React.createElement(BaseButton, tslib_1.__assign({}, this.props, { styles: baseButtonStyles }));
    };
    return FacepileButton;
}(BaseComponent));
export { FacepileButton };
//# sourceMappingURL=FacepileButton.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Facepile/FacepileButton.js
// module id = 806
// module chunks = 0